// Function-expansion warning helpers keep messages consistent across call paths.
// Example: unknown or recursive calls use one stable warning payload shape.
import type { LuisCompileWarning } from '../../types'
import type { ExpansionContext } from './expand-types'

// Build one warning write only when collection is enabled for the current expansion pass.
/** @internal Build one warning write only when collection is enabled for the current expansion pass. */
export function pushExpansionWarning(
  context: ExpansionContext,
  code: LuisCompileWarning['code'],
  line: number,
  message: string,
): void {
  // Check whether warning collection is enabled for this expansion pass.
  if (!context._collectWarnings) {
    // Return early when warning collection is disabled.
    return
  } else {
    // Continue warning creation for current expansion context.
  }

  context._warnings.push({ code, line, message })
}

// Build normalized statement-call text for fallback paths.
export function buildStatementCall(name: string, args: string[]): string {
  // Return @fun-prefixed call text.
  return `@fun.${name}(${args.join(', ')})`
}
